import { default as wasm0 } from './wasm0.js';
import { default as wasm1 } from './wasm1.js';
import { default as wasm2 } from './wasm2.js';
export default "" + wasm0() + wasm1() + wasm2();
